const BASE_API = 'https://api.brandfetch.io/v2/search/';

interface BrandFetchResponse {
  brandId: string;
  claimed: boolean;
  domain: string;
  icon: string;
  name: string;
  qualityScore: number;
  verified: boolean;
}

export const searchBrand = async (query: string): Promise<BrandFetchResponse[]> => {
  if (!query) return [];

  const response = await fetch(`${BASE_API}${query}`);
  const data = await response.json();

  return data;
};
